import { render, staticRenderFns } from "./v-slider.vue?vue&type=template&id=3b747951&scoped=true&"
import script from "./v-slider.vue?vue&type=script&lang=js&"
export * from "./v-slider.vue?vue&type=script&lang=js&"
import style0 from "./v-slider.vue?vue&type=style&index=0&id=3b747951&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b747951",
  null
  
)

export default component.exports